import { CommonThumbnailLogic } from '@src/slide/content-viewer/service/canvas-renderer/entry/thumbnail-mobile/logic/common-thumbnail-logic';
import type { InterfaceFactoryOptions } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/elements/factory-options.interface';
import type { ComponentFactory } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/elements/component-factory';
import { IMediaManager } from '@src/slide/application/service/media-manager/media-manager.interface';
import { IPictureModel } from '@src/slide/domain/ui-model/element-modeles/Interface/picture-model.interface';

export class PictureThumbnailLogic extends CommonThumbnailLogic {
    public mediaManager?: IMediaManager;

    public constructor(factoryOptions: InterfaceFactoryOptions<IPictureModel>, component: ComponentFactory) {
        super(factoryOptions, component);
        this.mediaManager = factoryOptions.mediaManager;
    }
}
